import { AxiosInstance } from 'axios';
import { parseModules, parseModule } from './utils';
import { ModulesStatusEnum } from './types';

export const getModulesData = (api: AxiosInstance) => ({
  getModules: async (
    params: any,
    parseData: Function = parseModules
  ): Promise<any> => {
    const { data } = await api.get(ModulesStatusEnum.EVENT_MODULES, {
      params,
    });
    return { ...data, data: parseData(data.data) };
  },
  getModulesByEventCard: async (
    params: any,
    parseData: Function = parseModules
  ): Promise<any> => {
    const { data } = await api.get(`event-modules/get`, {
      params,
    });
    return { ...data, data: parseData(data.data) };
  },
});

export const getModuleData = (api: AxiosInstance) => ({
  getModule: async (
    id: any,
    parseData: Function = parseModule
  ): Promise<any> => {
    const { data } = await api.get(`${ModulesStatusEnum.EVENT_MODULE}/${id}`);
    return { ...data, data: parseData(data.data) };
  },
});

export const modulesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getModulesData(api),
    ...getModuleData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/event-modules/modulesService.ts